import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { InformixCopySink } from 'app/model/pipeline/copysink/informix.copysink';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { CopySinkAdapter } from './copysink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(InformixCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchSize: '*',
        writeBatchTimeout: '*',
        preCopyScript: '*',
        maxConcurrentConnections: '*'
    }
})
export class InformixSinkAdapter extends TabularSinkAdapter<InformixCopySink, Model.CopySink> {
    protected override async _toResource(model: InformixCopySink): Promise<Model.CopySink> {
        const resource = CopySinkAdapter.getCommonCopySinkProperties(model, Metamodel.modelFor(InformixCopySink).name);
        if (model != null) {
            TabularSinkAdapter.toSinkResource(model, resource);
            CopySinkAdapter.toCommonCopySinkResource(model, resource, this.context);
        }
        return resource;
    }

    protected override async _toModel(resource: Model.CopySink, owner: Activity): Promise<InformixCopySink> {
        const model = Owned.create<InformixCopySink>(Metamodel.modelFor(InformixCopySink), owner);
        if (resource != null) {
            TabularSinkAdapter.toSinkModel(resource, model);
            CopySinkAdapter.toCommonCopySinkModel(model, resource);
        }
        return model;
    }
}
